import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import "./homePage.css";
import Header from "../components/common/header";
import Footer from "../components/common/footer";
import { useExchangeUser } from "../../contexts/userExchangeProgramContext";
import bannerExchangeImage from "../../assets/images/daikin_banner_new.png";
import axios from "axios";

interface OfferPrice {
  id: Number;
  program_id: Number;
  product_id: Number;
  label: string;
  base_price: string;
  tnc: string;
  is_active: Number;
  offer_price: string;
}

const ExchangeHomePage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const [offerPrice, setOfferPrice] = useState<OfferPrice[]>([]);
  const [priceExchangeStatus, setPriceExchangeStatus] = useState(false);
  const [exchangeProductPrice, setExchangeProductPrice] = useState<string>("");
  const [selectIndex, setSelectIndex] = useState(0);
  const [oldProductError, setOldProductError] = useState(false);
  const { setOldProduct, setBasePrice, allFieldCommanError, allCommanErrors } =
    useExchangeUser();
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const version = process.env.REACT_APP_VERSION;
  const prog_id = params.prog_id;

  // Checkbox states
  const [policyChecked, setPolicyChecked] = useState(false);
  const [exchangeValueChecked, setExchangeValueChecked] = useState(false);

  useEffect(() => {
    fetchOfferPriceInfo();
  }, []);

  useEffect(() => {
    fetchSeoMetaDetails()
  },[]);

const fetchSeoMetaDetails = async () => {
    try {
        const code = 'exchange_home_page'
        const response = await fetch(`${backendUrl}${version}seo-meta-details/${code}`,
          {  method: 'GET',
            headers:{
              // Accept:'aplication/json',
              "Content-Type": "application/json",
            },
            credentials: "include",
            mode:"cors"                  
          }
        );
        if (!response.ok) throw new Error('Failed to fetch categories');
        const data = await response.json();
        await changeTitleAndMetaTags(data.result.page_title, {description:data.result.meta_description,keywords:data.result.meta_tag});
    } catch (error) {
        //console.error('Error fetching categories:', error);
    }
  };
  
  const changeTitleAndMetaTags = async (
    title: string,
    metaTags: { description?: string; keywords?: string; [key: string]: string | undefined }
  ) => {
    try {
        // Update the document title
        if (title) {
            document.title = title;
        } else {
            document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
        }
  
        // Update or create meta tags
        Object.keys(metaTags).forEach((metaName) => {
            const metaTag = document.querySelector(`meta[name="${metaName}"]`);
            if (metaTag) {
                // Update existing meta tag
                metaTag.setAttribute('content', metaTags[metaName] || `Default ${metaName} for Selsmart`);
            } else {
                // Create new meta tag if it doesn't exist
                const newMetaTag = document.createElement('meta');
                newMetaTag.name = metaName;
                newMetaTag.content = metaTags[metaName] || `Default ${metaName} for Selsmart`;
                document.head.appendChild(newMetaTag);
            }
        });
  
        // Cleanup function to reset the title and meta tags when unmounting
        return () => {
            document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
            Object.keys(metaTags).forEach((metaName) => {
                const metaTag = document.querySelector(`meta[name="${metaName}"]`);
                if (metaTag) {
                    metaTag.setAttribute('content', `Default ${metaName} for Selsmart`);
                }
            });
        };
    } catch (error) {
        //console.error("Error updating title and meta tags:", error);
    }
  };
  const fetchOfferPriceInfo = async () => {
    //console.log("program id ", prog_id, backendUrl);
    try {
      const response = await axios.get(
        `${
          backendUrl ? backendUrl : "http://localhost:8000/"
        }api/v2/program-products/${prog_id}`
      );
      //console.log("response json", response);
      const data = await response.data;
      setOfferPrice(data.data);
      //console.log("response json data", data);
    } catch (err) {
      //console.log("errrorrrr", err);
    }
  };

  const handleSubmitForm = () => {
    //console.log("sumbmit form in first page", priceExchangeStatus);
    if (priceExchangeStatus) {
      navigate("/exchange/product-form", {
        state: { program_id: prog_id, old_product: offerPrice[selectIndex] },
      });
      window.scrollTo({ top: 0, behavior: 'smooth' })
    } else {
      setOldProductError(true);
      return;
    }
  };

  // const handleSelectOldProduct = (e:React) => {

  // }

  // const fetchAllInfoData = async () => {
  //   try {
  //     const response = await fetch(
  //       `${backendUrl}api/v2/order-info/${order_id}`
  //     );
  //     const data = await response.json();

  //     if (data.data) {
  //       setOrderInfo(data.data || []);
  //     } else {
  //       setError("No stores found for the entered pincode");
  //     }
  //   } catch (err: any) {
  //     setError("Error fetching store options");
  //   }
  // };

  // const updateTncCheck = async () => {
  //   try {
  //     const response = await fetch(
  //       `${backendUrl}api/v2/tnc-check/${order_id}/${user_id}`,
  //       {
  //         method: "PATCH",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );
  //     const data = await response.json();
  //     navigate("/exchange/verify-otp");
  //     // Handle the response as needed
  //   } catch (err: any) {
  //     // Handle the error as needed
  //   }
  // };

  // const handleConfirmExchange = () => {
  //   if (!policyChecked || !exchangeValueChecked) {
  //     // Show errors for unchecked checkboxes
  //     setShowPolicyError(!policyChecked);
  //     setShowExchangeError(!exchangeValueChecked);
  //   } else {
  //     // Perform the action if both checkboxes are checked
  //     updateTncCheck();
  //   }
  // };

  // Check if both checkboxes are checked to enable the button
  const isConfirmButtonEnabled = policyChecked && exchangeValueChecked;
  useEffect(() => {
    localStorage.removeItem("exchange_order_id");
    localStorage.removeItem("exchange_user_id");
    localStorage.removeItem("exchange_servicable_pincode");
    localStorage.removeItem("exchange_selected_old_product");
    localStorage.removeItem("exchange_base_price");
    localStorage.removeItem("exchange_cust_info");
    sessionStorage.removeItem('mobile_no');
  }, []);

  return (
    <div>
      <Header />
      <main className="main-content-home">
        <div className="container partnership-brand">
          <h1 className="h1Title">
            <p className="partner-heading">DAIKIN GREEN EXCHANGE PROGRAM</p>  

            <p className="partner-subheading">
              <span style={{ fontStyle: "italic" }}>Powered by</span> ATTERO
            </p>
          </h1>
          <div className="partner-banner-container">
            <img src={bannerExchangeImage} className="partner-banner-img" alt='Selsmart-banner'/>
          </div>
          <div className="partner-form-container ">
            <div className="partner-form-select-container">
              <label>Old Product Details <span className="astric">*</span></label>
              <select
                className="partner-form-select form-select"
                onChange={(e: any) => {
                  // //console.log("e.target.value     ", e.target.value)
                  if (e.target.value === "-2") {
                    //console.log("if (e.target.value)", e.target.value);
                    setPriceExchangeStatus(false);
                  } else {
                    //console.log("elseif (e.target.value)", e.target.value);
                    setPriceExchangeStatus(true);
                  }
                  setExchangeProductPrice(
                    offerPrice[e.target.value]?.offer_price
                  );
                  setSelectIndex(e.target.value);
                  setOldProduct(offerPrice[e.target.value]?.label);
                  setBasePrice(offerPrice[e.target.value]?.offer_price);
                  setOldProductError(false);
                }}
              >
                <option value="-2">Select Old Product</option>
                {offerPrice.map((it, i) => (
                  <option key={i} value={i}>
                    {it.label}
                  </option>
                ))}
              </select>
              {oldProductError && (
                <div className="comman-error">
                  {allCommanErrors.old_product}
                </div>
              )}
            </div>

            <div className="partner-form-select-container">
              <label>New Daikin Product Details <span className="astric">*</span></label>
              <select
                className="partner-form-select form-select"
                value={offerPrice[1]?.label}
              >
                <option value="">{offerPrice[1]?.label}</option>
              </select>
            </div>
            <div className="partner-exchange-price">
              <div className="price-heads">Exchange Value :</div>
              {priceExchangeStatus && (
                <>
                  <span className="partner-exchange-amount d-flex">
                   <span className="rupes_symbol"> &#8377;</span>
                   <div className="exchange_amount"> {exchangeProductPrice}</div>
                  </span>
                  <span>
                    <span style={{ color: "#0A966F", fontWeight:"400" }}>
                      Subject to Quality Check of the Product
                    </span>
                    <br />
                    <span style={{ color: "red" }}>*T&C Applied</span>
                  </span>
                </>
              )}
            </div>
          </div>
          <div className="partner-form-btn-container ">
            <button
              className="partner-proceed-form-btn"
              onClick={handleSubmitForm}
            >
              Proceed to Form
            </button>
          </div>
          <div className="section-tnc ">
            <h3 className="partner-tnc-subhaeding">Terms and Conditions -</h3>
          </div>
          <div className="tnc-list-container ">
            <ul className="tnc-unorder-list">
              <li className="tnc-list-text">
                Customers who have purchased a New Daikin Air Conditioner (AC)
                are eligible to participate.
              </li>
              <li className="tnc-list-text">
                Old AC should be available with all the parts and components.
              </li>
              <li className="tnc-list-text">
                Please ensure the product is kept un-installed and ready for
                pickup.
              </li>
              <li className="tnc-list-text">
                Please ensure that New Daikin AC is installed by Daikin
                Authorized Service Provider.
              </li>
              <li className="tnc-list-text">
                In case of cancellation or refusal for pickup of Old AC by the
                customer, exchange amount is not applicable.
              </li>
              <li className="tnc-list-text">
                Purchase date should be less than 30 days to be eligible for
                this exchange program.
              </li>
              <li className="tnc-list-text">
                This exchange offer is for individuals not businesses.
              </li>
              <li className="tnc-list-text">
                Customer agrees that the mobile number and email address
                provided will be used for all communications regarding your
                exchange program, including SMS, email, and WhatsApp messages.
              </li>
            </ul>
            <div className="tnc-heads">Exchange Process:</div>
            <ul className="tnc-unorder-list">
              <li className="tnc-list-text">
                Select Old product details and New Daikin product details to get
                an exchange value.
              </li>
              <li className="tnc-list-text">
                Select the City name and PIN code to check where Exchange
                program is currently running.
              </li>
              <li className="tnc-list-text">
                Click on proceed to form and enter Mobile no , address details
                for pickup , Old AC brand details , Invoice No. of New AC,
                Purchase Date and upload the invoice of New AC (pdf, jpg, jpeg
                and png format only).
              </li>
              <li className="tnc-list-text">
                Proceed to Personal Details page and fill in all the details
                like name, mobile no., email and address.
              </li>
              <li className="tnc-list-text">
                Accept the Terms and Conditions and accept the exchange value by
                checking all the boxes.
              </li>
              <li className="tnc-list-text">
                Enter the OTP received via SMS and E-mail to complete the
                process.
              </li>
              <li className="tnc-list-text">
                You will receive a SMS and E-mail with your Order Number against
                the pickup of your Old AC.
              </li>
              <li className="tnc-list-text">
                Your request for Installation of New Daikin AC has also been
                generated and communicated vai SMS/ whatsapp at your contact
                no.Please do not place separate installation request vai calling
                Daikin call centre / website.
              </li>
              <li className="tnc-list-text">
                Daikin Authorized service provider will call and visit at your
                address for installation of New Daikin AC.
              </li>
              <li className="tnc-list-text">
                Attero will arrange for the pickup of the Old AC after Daikin
                has installed the New AC by contacting and confirming the pickup
                date.
              </li>
              <li className="tnc-list-text">
                Ensure that the Old AC is un-installed and is ready for
                collection and accessible at the pickup address.
              </li>
              <li className="tnc-list-text">
                Logistics Provider will visit the address and perform quality
                check. If everything is as per the terms and conditions of the
                Exchange Program, payout link will be sent to the Customer’s
                mobile no. via authorized third-party payment gateway provider.
              </li>
              <li className="tnc-list-text">
                The Old AC will be picked up by the Logistics Partner and this
                Exchange program will be completed.
              </li>
            </ul>
            <div className="tnc-heads">Contact Information:</div>
            <ul className="tnc-unorder-list">
              <li className="tnc-list-text">
                For assistance or inquiries related to Daikin Green Exchange
                Program or Old AC pickup, please contact our customer care at{" "}
                <a href="tel:9355541464">9355541464</a>
              </li>
              <li className="tnc-list-text">
                For assistance or inquiries related to New Daikin AC, please
                contact Daikin customer care.
              </li>
            </ul>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ExchangeHomePage;
